/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-06-29 22:52:45
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-07-21 19:10:51
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Currency/Components/CurrencyModal/index.tsx
 */
import React from 'react';

import useService from './service';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { Radio, InputNumber, Popover, Checkbox } from 'antd';
import { Modal, Select, Button, Input } from '@/src/components/Antd';
import { Icon } from '@/src/tools/icon';
import styles from './style.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { get } from 'lodash';
type Props = {
  visible: boolean;
  onCancel: () => void;
  currencyList: Array<any>;
  editingCurrency: any;
  onSubmit: (body: any) => void;
  afterClose: () => void;
};

function CurrencyModal({
  visible,
  currencyList,
  editingCurrency,
  onCancel,
  onSubmit,
  afterClose,
}: Props) {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    // isChanged,
    error,
    realTimeRate,
    currency,
    options,
    reportingCurrencies,
    handleSubmit,
    handleChange,
    handleChangeMax,
    handleChangeMin,
    handleChangeRate,
    handleChangeFluRate,
    handleChangeFixedRate,
  } = useService(currencyList, editingCurrency);

  const isInList = (currencyList || []).find(
    (i) => i.currencyCode === get(currency, 'currencyCode'),
  );

  const currencyOptions = options.map((o) => ({
    label: o.label,
    value: o.code,
  }));
  const hasValue = get(currency, 'currencyCode');
  return (
    <Modal
      width={600}
      title={getI18n('storeCurrency.detail.addCurrency')}
      visible={visible}
      onCancel={onCancel}
      afterClose={afterClose}>
      <div className={styles.content}>
        <ItemWrapper title={getI18n('storeCurrency.detail.currency')}>
          <Select
            //labelInValue
            // value={{
            //   value: currency.currencyCode,
            //   label: currency.currencyName,
            // }}
            value={currency.currencyCode}
            onChange={(currencyCode) => {
              const obj = currencyOptions.find((i) => i.value === currencyCode);
              handleChange(obj);
            }}
            options={currencyOptions}
            size={'large'}
            placeholder={`${getI18n('general.select')}...`}></Select>
        </ItemWrapper>
        {currency.currencyCode && (
          <ItemWrapper title={getI18n('storeCurrency.detail.exchangeRate')}>
            <div className={styles.rates}>
              <Radio
                onChange={handleChangeFixedRate.bind(this, true)}
                checked={currency.fixedRate}>
                {getI18n('storeCurrency.detail.fixedRate')}
              </Radio>
              {currency.fixedRate && (
                <div className={styles.items}>
                  <div className={styles.item}>
                    <div className={styles.title}>
                      {getI18n('storeCurrency.detail.setRate')}
                    </div>
                    <div className={styles.input}>
                      <InputNumber
                        min={0}
                        className={styles.inputNumber}
                        onChange={handleChangeRate}
                        value={currency.rate}
                      />
                    </div>
                  </div>
                  <div className={styles.item} style={{ marginLeft: '32px' }}>
                    <div className={styles.title}>
                      {' '}
                      {getI18n('storeCurrency.detail.reportingCurrency')}
                    </div>
                    <div
                      className={
                        styles.input
                      }>{`${reportingCurrencies.code} 1.00`}</div>
                  </div>
                  <div className={styles.item} style={{ marginLeft: '32px' }}>
                    <div className={styles.title}>
                      {getI18n('storeCurrency.detail.addedCurrency')}
                    </div>
                    <div className={styles.input}>
                      {`${currency.currencyCode} ${currency.rate}`}
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className={styles.rates} style={{ marginTop: '22px' }}>
              <Radio
                onChange={handleChangeFixedRate.bind(this, false)}
                checked={!currency.fixedRate}>
                <span>
                  <span> {getI18n('storeCurrency.detail.realTimeRate')}</span>
                  <Popover placement={'right'} title={null} content={<Hint />}>
                    <Icon type='icontooltip' className={styles.icon} />
                  </Popover>
                </span>
              </Radio>
              {!currency.fixedRate && (
                <>
                  <div className={styles.items}>
                    <div className={styles.item}>
                      <div className={styles.title}>
                        {' '}
                        {getI18n('storeCurrency.detail.convertionRate')}
                      </div>
                      <div className={styles.input}>{`${realTimeRate}`}</div>
                    </div>
                    <div className={styles.item} style={{ marginLeft: '32px' }}>
                      <div className={styles.title}>
                        {getI18n('storeCurrency.detail.reportingCurrency')}
                      </div>
                      <div
                        className={
                          styles.input
                        }>{`${reportingCurrencies.code} 1.00`}</div>
                    </div>
                    <div className={styles.item} style={{ marginLeft: '32px' }}>
                      <div className={styles.title}>
                        {' '}
                        {getI18n('storeCurrency.detail.addedCurrency')}
                      </div>
                      <div
                        className={
                          styles.input
                        }>{`${currency.currencyCode} ${realTimeRate}`}</div>
                    </div>
                  </div>
                  <div className={styles.additional}>
                    <div className={styles.max}>
                      <Checkbox
                        className={styles.checkbox}
                        checked={get(currency, 'maxRateChecked')}
                        onChange={handleChangeMax}>
                        {getI18n('storeCurrency.detail.maximumrate')}
                      </Checkbox>
                      {get(currency, 'maxRateChecked') ? (
                        <InputNumber
                          min={0}
                          style={{
                            borderColor: ['max&min', 'maxNull'].includes(
                              error.type,
                            )
                              ? '#FF695F'
                              : undefined,
                          }}
                          value={currency.maxRate}
                          disabled={!get(currency, 'maxRateChecked')}
                          size={'large'}
                          className={styles.maxInput}
                          onChange={handleChangeFluRate.bind(this, 'max')}
                        />
                      ) : (
                        <Input
                          style={{
                            borderColor:
                              error.type === 'max&min' ? '#FF695F' : undefined,
                          }}
                          value={'No Limit'}
                          disabled={true}
                          className={styles.maxInput}
                          size={'large'}
                        />
                      )}
                    </div>
                    <div className={styles.min}>
                      <Checkbox
                        className={styles.checkbox}
                        checked={get(currency, 'minRateChecked')}
                        onChange={handleChangeMin}>
                        {getI18n('storeCurrency.detail.minimumrate')}
                      </Checkbox>
                      <InputNumber
                        min={0}
                        style={{
                          borderColor: ['max&min', 'minNull'].includes(
                            error.type,
                          )
                            ? '#FF695F'
                            : undefined,
                        }}
                        disabled={!get(currency, 'minRateChecked')}
                        value={currency.minRate}
                        size={'large'}
                        className={styles.minInput}
                        onChange={handleChangeFluRate.bind(this, 'min')}
                      />
                    </div>
                  </div>
                  {error.message && (
                    <div className={styles.error}>{error.message}</div>
                  )}
                </>
              )}
            </div>
          </ItemWrapper>
        )}
      </div>
      <div className={styles.footer}>
        <Button onClick={onCancel}>{getI18n('general.cancel')}</Button>
        <Button
          className={styles.button}
          type='primary'
          disabled={hasValue ? false : true}
          onClick={() => {
            if (handleSubmit()) {
              onSubmit(currency);
              onCancel();
            }
          }}>
          {isInList
            ? getI18n('general.saveChanges')
            : getI18n('general.linkModule.Modal.add')}
        </Button>
      </div>
    </Modal>
  );
}
export default CurrencyModal;

const Hint = () => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  return (
    <div className={styles.hint}>
      <div className={styles.hintTitle}>
        {getI18n('storeCurrency.detail.realTimeRate')}
      </div>
      <p className={styles.paragraph}>
        {getI18n('storeCurrency.detail.hint1')}
      </p>
      <p className={styles.paragraph}>
        {getI18n('storeCurrency.detail.hint2')}
      </p>
    </div>
  );
};
